export function ellipsis (str, length, replaceStr) {
  if (!str || str.length <= length) {
    return str
  }
  return str.slice(0, length) + replaceStr
}
